/* 太史慈傳・第 4 章：海昏・拒劉磐（建安四年～十一年，199–206）
 * 史實：《三國志·太史慈傳》「劉表從子磐，驍勇，數為寇於艾、西安諸縣。策於是分海昏、建昌左右六縣，以慈為建昌都尉，治海昏，
 *       并督諸將拒磐。磐絕跡不復為寇。」「曹公聞其名，遺慈書，以篋封之，發省無所道，而但貯當歸。孫權統事，以慈能制磐，
 *       遂委南方之事。年四十一，建安十一年卒。」裴注引《吳書》：「慈臨亡，歎息曰：『丈夫生世，當帶七尺之劍，以升天子之階。
 *       今所志未從，奈何而死乎！』」
 * 流程：1. 督諸將：海昏有三營兵待命，到艾、西安、建昌站著「部署」，就有一營開過去駐守。
 *       2. 磐寇諸縣：劉磐的兵分三波從西邊下來，每縣有民心，被寇掠就掉；有兵駐守掉得慢。哪一縣被寇掠一空就輸。
 *       3. 第三波劉磐親自領兵；打到三成以下他就退走，磐絕跡不復為寇。
 *       4. 結局：打開曹操送來的篋（只有當歸）；孫權統事、委南方之事；臨終之歎。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, boss, rout } from '../kit.ts';
import { TSC_PEOPLE, TSC_TROOPS, box } from './taishici_kit.ts';
import { HAIHUN, COUNTIES, WEST } from '../maps/taishici_haihun.ts';

const LV = 12, SQUADS = 3, PER = 4;
const PAN = { spec: TSC_TROOPS.liupan, name: '劉磐兵', hp: 620, maxHp: 620, atk: 28 };
// 三波：[開始的秒數, [[從哪條路, 打哪一縣, 人數], ...], 劉磐親自來不來]
const WAVES = [
  [55, [['ai', 'ai', 6]]],
  [110, [['xian', 'xian', 6], ['ai', 'jc', 5]]],
  [175, [['xian', 'xian', 5], ['mid', 'ai', 5]], true],
];

export default {
  id: 'taishici-4', map: 'taishici_haihun', hero: 'taishici',
  title: '第 4 章　海昏・拒劉磐', year: '建安四年（199）～十一年（206）',
  brief: {
    quote: [
      { text: '劉表從子磐，驍勇，數為寇於艾、西安諸縣。', src: '《三國志·吳書·太史慈傳》' },
      { text: '策於是分海昏、建昌左右六縣，以慈為建昌都尉，治海昏，并督諸將拒磐。', src: '《太史慈傳》' },
    ],
    text: '孫策平定豫章之後，劉表的姪子劉磐屢次從西邊來寇掠艾、西安等縣。孫策把海昏、建昌一帶劃出來，任太史慈為建昌都尉，治所設在海昏，督率諸將抵禦劉磐。',
    goals: ['把三營兵部署到艾、西安、建昌', '擊退劉磐的三波寇掠，別讓哪一縣被掠一空', '第三波：親自擊退劉磐'],
  },
  words: { ally: '都尉兵', foe: '劉磐兵' },
  stars: [
    { text: '第一波到之前三營都部署好', ok: (m) => m.vars.readyEarly },
    { text: '四縣的民心都在五成以上', ok: (m) => COUNTIES.every((c) => m.vars.min[c.id] >= 50) },
    { text: '親自擊退劉磐', ok: (m) => m.vars.byHand },
  ],
  steps: [
    { // 0. 督諸將、磐寇諸縣
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = HAIHUN[0] - 300; me.y = HAIHUN[1] + 100;
        V.t0 = w.t; V.wave = 0; V.deployed = 0; V.min = {}; V.raiders = [];
        V.c = {};
        for (const c of COUNTIES) { V.c[c.id] = { ...c, pop: 100, guard: null }; V.min[c.id] = 100; if (c.id !== 'hh') m.mark(c.id, c.x, c.y, `${c.name}（部署）`, true); }
        // 三營兵在治所待命；海昏另有本營的兵
        V.squads = Array.from({ length: SQUADS }, (_, s) => Array.from({ length: PER }, (_, i) => { const u = m.recruit(HAIHUN[0] - 400 + i * 70, HAIHUN[1] - 250 + s * 90, '都尉兵'); Object.assign(u, { hp: 760, maxHp: 760, atk: 26, home: [u.x, u.y] }); return u; }));
        V.c.hh.guard = Array.from({ length: PER }, (_, i) => { const u = m.recruit(HAIHUN[0] + 150 + i * 60, HAIHUN[1] - 60, '海昏守兵'); Object.assign(u, { hp: 760, maxHp: 760, atk: 26, home: [u.x, u.y] }); return u; });
        m.card('策於是分海昏、建昌左右六縣，以慈為建昌都尉，治海昏，并督諸將拒磐。', '《太史慈傳》');
        m.after(4, () => m.line('提示', '三營兵在海昏待命。到艾、西安、建昌站著「部署」，就有一營開過去駐守。劉磐的兵會從西邊來。'));
        m.obj('deploy', '部署三營兵', SQUADS);
        m.obj('pop', '');
        m.obj('wave', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, T = w.t - V.t0;
        // 部署
        for (const c of COUNTIES) {
          const C = V.c[c.id];
          if (c.id === 'hh' || C.guard || V.deployed >= SQUADS) continue;
          m.chanAt(me, 'dep' + c.id, c.x, c.y, 260, 2, '部署', () => {
            const sq = V.squads[V.deployed++];
            C.guard = sq; m.unmark(c.id); m.prog('deploy', V.deployed);
            sq.forEach((u, i) => { u.home = [c.x - 90 + (i % 2) * 180, c.y + 120 + Math.floor(i / 2) * 80]; });
            m.line('都尉兵', `一營往${c.name}駐守！`);
            if (V.deployed === SQUADS) { m.done('deploy'); V.readyEarly = V.wave === 0; }
          });
        }
        // 寇掠
        const W = WAVES[V.wave];
        if (W && T >= W[0]) {
          V.wave++;
          m.big(W[2] ? '劉磐親自來了！' : `劉磐寇掠（第 ${V.wave} 波）`);
          for (const [from, to, n] of W[1]) {
            const [x, y] = WEST[from], C = V.c[to];
            for (let i = 0; i < n; i++) { const u = m.foe('huangjin', x + (i % 3) * 60, y + Math.floor(i / 3) * 70, PAN); u.home = [C.x, C.y]; u.raid = to; V.raiders.push(u); }
            m.line('斥候', `劉磐的兵往${C.name}去了！`);
          }
          if (W[2]) {
            V.pan = boss(w, TSC_PEOPLE.liupan, WEST.xian[0] + 100, WEST.xian[1] - 100, { name: '劉磐', hp: 6500, maxHp: 6500, atk: 60, armor: 9, ms: 255 });
            V.pan.home = [V.c.xian.x, V.c.xian.y]; V.pan.raid = 'xian';
            m.mark('pan', V.pan.x, V.pan.y, '劉磐', false, V.pan);
            m.after(2, () => m.line('劉磐', '太史慈？聽說是個會射箭的。今天艾、西安都歸我！'));
          }
        }
        // 民心：縣城附近有寇兵就掉，有自己的兵在就掉得慢
        for (const c of COUNTIES) {
          const C = V.c[c.id];
          const foes = w.units.filter((u) => u.team === 1 && u.alive && !u.rout && SG.gd(u.x, u.y, c.x, c.y) < 420).length;
          if (!foes) continue;
          const held = C.guard && C.guard.some((u) => u.alive && SG.gd(u.x, u.y, c.x, c.y) < 520);
          C.pop = Math.max(0, C.pop - foes * (held ? 0.35 : 1.1) * dt);
          V.min[c.id] = Math.min(V.min[c.id], C.pop);
          if (C.pop <= 0) { m.lose(`${c.name}被劉磐寇掠一空`); return false; }
        }
        // 被寇掠過的縣：寇兵打完了就往下一縣（海昏）去
        for (const u of V.raiders) if (u.alive && u.raid !== 'hh' && !w.units.some((g) => g.team === 0 && g.alive && SG.gd(g.x, g.y, u.x, u.y) < 600) && V.c[u.raid].pop < 40) { u.raid = 'hh'; u.home = HAIHUN.slice(); }
        m.get('pop').text = '民心：' + COUNTIES.map((c) => `${c.name} ${Math.ceil(V.c[c.id].pop)}`).join('　');
        const next = WAVES[V.wave];
        m.get('wave').text = next ? `第 ${V.wave + 1} 波寇掠：${Math.max(0, Math.ceil(next[0] - T))} 秒後` : '擊退劉磐';
        // 劉磐打到三成以下就退走
        const P = V.pan;
        if (P && P.alive && P.hp < P.maxHp * 0.3) { V.byHand = m.near(me, P.x, P.y, 700); return true; }
        return false;
      },
    },
    { // 1. 磐絕跡不復為寇
      enter(m, w) {
        const V = m.vars;
        m.drop('wave'); m.unmark('pan');
        rout(m, w, [V.pan].concat(V.raiders), WEST.mid);
        m.big('劉磐退走');
        m.card('磐絕跡不復為寇。', '《太史慈傳》');
        m.after(4, () => {
          m.line('使者', '都尉，許都曹公派人送來一個篋，封得好好的。');
          V.box = m.folk(HAIHUN[0] + 60, HAIHUN[1] + 40, { name: '篋', still: true, near: 1, draw: box });
          m.mark('box', HAIHUN[0] + 60, HAIHUN[1] + 40, '曹公的篋');
          m.obj('box', '回海昏，打開曹操送來的篋');
        });
      },
      tick(m, w) {
        const V = m.vars;
        if (V.box) m.chanAt(w.player, 'box', V.box.x, V.box.y, 200, 2, '發篋', () => { V.opened = true; });
        return !!V.opened;
      },
    },
    { // 2. 結局
      enter(m, w) {
        const V = m.vars;
        m.done('box'); m.unmark('box');
        V.box.name = '當歸';
        m.card('曹公聞其名，遺慈書，以篋封之，發省無所道，而但貯當歸。', '《太史慈傳》');
        m.after(3, () => m.line('太史慈', '……當歸。'));
        m.after(6, () => m.card('孫權統事，以慈能制磐，遂委南方之事。年四十一，建安十一年卒。', '《太史慈傳》'));
        m.after(11, () => m.card('慈臨亡，歎息曰：「丈夫生世，當帶七尺之劍，以升天子之階。今所志未從，奈何而死乎！」權甚悼惜之。', '裴注引《吳書》'));
        m.after(16, () => m.card('子享，官至越騎校尉。', '《太史慈傳》'));
        m.after(19, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) { if (!w.player.alive) m.lose('太史慈陣亡，諸縣無人督守'); },
};
